import { render, staticRenderFns } from "./DrawerCommTab.vue?vue&type=template&id=397197ac&scoped=true"
import script from "./DrawerCommTab.vue?vue&type=script&lang=js"
export * from "./DrawerCommTab.vue?vue&type=script&lang=js"
import style0 from "./DrawerCommTab.vue?vue&type=style&index=0&id=397197ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397197ac",
  null
  
)

export default component.exports